import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function ManymoonsMarketplace() {
  return <section className="w-full bg-cream px-5 py-20 sm:px-8 lg:py-28" aria-labelledby="manymoons-heading" data-id="element-979" data-mp="3obhsj7hyayoz">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative mx-auto flex min-h-[500px] max-w-6xl items-center justify-center overflow-hidden rounded-3xl bg-ink px-6 py-16 text-center text-cream sm:min-h-[560px] sm:px-12" data-id="element-980" data-mp="6ugtbixl6uyy">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/c16d8b38-ce77-4de3-a914-ef5d27ea5ddb.jpg" alt="Curated garments and fulfillment inventory in the Manymoons managed marketplace" className="absolute inset-0 h-full w-full object-cover" data-id="element-981" data-mp="3jaby958n73dc" />
        <div className="absolute inset-0 bg-ink/65" aria-hidden="true" data-id="element-982" data-mp="umxc5vp5eqzb" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/55 via-transparent to-ink/30" aria-hidden="true" data-id="element-983" data-mp="1bv6yknbycez3" />

        <div className="relative flex max-w-3xl flex-col items-center" data-id="element-984" data-mp="1gwwcqbuh18re">
          <span aria-label="Manymoons sparkle" className="h-7 w-7 bg-cream" style={{
          WebkitMaskImage: 'url(https://cdn.magicpatterns.com/uploads/uszYpUgDHbmVmVvdioqNYy/Icon_OffWhite.svg)',
          maskImage: 'url(https://cdn.magicpatterns.com/uploads/uszYpUgDHbmVmVvdioqNYy/Icon_OffWhite.svg)',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
          WebkitMaskSize: 'contain',
          maskSize: 'contain'
        }} data-id="element-985" data-mp="1kxol72vir9mm" />
          <img src="https://cdn.magicpatterns.com/uploads/qwMGaj21p1yjbuSJerdC6f/manymoons_offwhite.svg" alt="Manymoons" className="mt-8 h-auto w-64 max-w-full sm:w-80" data-id="element-986" data-mp="9gydtgfd0brf" />
          <h2 id="manymoons-heading" className="mt-8 font-display text-3xl font-medium leading-tight tracking-tight sm:text-4xl" data-id="element-987" data-mp="1hovudoa77cd8">
            The elevated standard for inventory recovery.
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-cream/85 sm:text-lg" data-id="element-988" data-mp="1mhxc041shq0i">
            Manymoons transforms off-price recovery from transactional to aspirational. We manage the logistics and customer experience, connecting your inventory with a community that values craftsmanship over cost.
          </p>
          <a href="https://manymoons.com" target="_blank" rel="noreferrer" className="group mt-8 inline-flex items-center gap-2 border-b border-cream/60 pb-1 text-sm font-semibold text-cream transition-colors hover:border-cream hover:text-white" data-id="element-989" data-mp="17tkev3qyu14f">
            Explore Manymoons
            <ArrowUpRightIcon className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-990" data-mp="2e8lat9fzqjb0" />
          </a>
        </div>
      </motion.div>
    </section>;
}